const Button = ({copy,link,target, className, id, onClick}) =>(
    <>
        <a href={link} onClick={()=>onClick} target={target} id={id} className={`button ${className}`}>{copy}</a>
    </>
)

Button.defaultProps={
    copy: "Prueba Premium gratis",
    link: "#",
    className: "",
    id: "",
    onClick: "",
    target:""
}
export default Button;